import React from 'react';

import Icon, { faPlus } from '~components/icon';

interface ComponentProps {
  id?: string;
  colSpan: number;
  canAdd?: boolean;
  showPagination?: boolean;
  onAddRow?: () => void;
  onLoadMore?: () => void;
}

const TableFooter: React.FC<ComponentProps> = ({
  id,
  colSpan,
  canAdd,
  showPagination = false,
  onAddRow,
  onLoadMore,
}) => {
  return (
    <tfoot>
      {canAdd && (
        <tr>
          <td className="add-row" colSpan={colSpan} onClick={() => onAddRow?.()} data-cy={`${id}-table-add-row`}>
            <Icon icon={faPlus} className="me-1" />
          </td>
        </tr>
      )}
      {showPagination && (
        <tr>
          <td
            className="p-3 text-center selectable fw-bold"
            colSpan={colSpan}
            onClick={() => onLoadMore?.()}
            data-cy={`${id}-table-load-more`}
          >
            LOAD MORE
          </td>
        </tr>
      )}
    </tfoot>
  );
};

export default TableFooter;
